import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useLogger } from '../../../context';
import { ErrorPage } from '../ErrorPage';
const DEFAULT_ERROR_BOUNDARY_NAME = 'RenderingError';
export const ErrorBoundary = ({ children, tags, mfe, team, errorName = DEFAULT_ERROR_BOUNDARY_NAME, }) => {
    const logger = useLogger();
    const onError = (error, info) => {
        const renderingError = new Error(error.message);
        renderingError.stack = info.componentStack;
        renderingError.cause = error;
        logger.error(errorName, renderingError, {
            mfe,
            team,
            ...tags,
        });
    };
    return (React.createElement(ReactErrorBoundary, { fallback: React.createElement(ErrorPage, null), onError: onError }, children));
};
